import { Button, Container, Divider, FormControl, Grid, IconButton, InputAdornment, TextField, Typography, FormHelperText, Tooltip, MenuItem } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { Add, CloudDownload, CloudUpload } from "@mui/icons-material";
import * as queryString from "query-string";
import React, { useEffect, useRef, useState } from "react";
import { QrReader } from "react-qr-reader";
import { useHistory } from "react-router-dom";
import Autocomplete from "@mui/material/Autocomplete";
import { getFormDataFromFiles, getSelectedFileNames, qrScroll } from "../../common";
import LoadingBackdrop from "../../components/LoadingBackdrop/LoadingBackdrop";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { tr } from "date-fns/esm/locale";
import ls from "local-storage";
import DatePicker from "react-multi-date-picker";
import { rrulestr } from "rrule";
import { isMobile } from "react-device-detect";
import DocumentPopup from "../../components/Popup/DocumentPopup";
import RecurrencePopup from "../../components/Popup/RecurrencePopup";
import RuleGenerator from "../../components/RuleGenerator/RuleGenerator";
import ReactTooltip from "react-tooltip";
import moment from "moment";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { getMaintenanceType, getAMGetOrderDetailById, amCreateOrderAfter, amUpdateOrderAfter, postAMCreateOrder, postAMUpdateOrder } from "../../store/actions/AMActions";
import { getEqGetByBarcodeContext } from "../../store/actions/EquipmentAction";
import { deleteAutonomousFiles, getAutonomousFiles, addAutonomousFiles } from "../../store/actions/AutonomousMaintenanceDetailActions";
import { getList } from "../../store/actions/CheckItemGroupActions";
import GroupItemListPopup from "../../components/Popup/GroupItemListPopup";
import Machine from "../../components/TextFields/Machine/Machine";
import FileUploaderPopup from "../../components/Popup/FileUploaderPopup";
import QrCode2Icon from "@mui/icons-material/QrCode2";
import CropFreeIcon from "@mui/icons-material/CropFree";
import SearchIcon from "@mui/icons-material/Search";

const useStyles = makeStyles((theme) => ({
    button: {
        width: 80,
        height: 80,
        padding: 0,
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
    },
    container: {
        display: "flex",
        flexWrap: "wrap",
    },
}));

export default function EditAutonomousMaintenanceOrder(props) {
    const classes = useStyles();
    const [pageLoaded, setPageLoaded] = useState(false);
    const [recurrencePopupIsOpen, setRecurrencePopupIsOpen] = useState(false);
    const [recurrence, setRecurrence] = useState([]);
    const [ruleString, setRuleString] = useState("");
    const [ruleText, setRuleText] = useState("");

    const autonomousMaintenanceId = queryString.parse(window.location.search).id;
    const fromPage = queryString.parse(window.location.search).from;
    const { t } = useTranslation("translation");
    const dispatch = useDispatch();

    useEffect(() => {
        if (fromPage !== "list") {
            setEquipment(queryString.parse(window.location.search).equipmentDetailed, queryString.parse(window.location.search).equipmentName);
        }

        loadHandler();
    }, []);

    const loadHandler = () => {
        loadGroupItemListData(false);
        if (autonomousMaintenanceId !== undefined) getAutonomousMaintenanceOrder();

        loadMaintenanceTypesData();
        setPageLoaded(true);
    };

    const setEquipment = (id, name) => {
        if (id != null && name != null) {
            setMachineStates({ ...machineStates, selectedMainEquipmentCode: Number(id), selectedMainEquipmentName: name });
        }
    };

    const { am } = useSelector((am) => am);
    const { equipment } = useSelector((state) => state);
    const AutonomousMaintenanceDetail = useSelector((state) => state.AutonomousMaintenanceDetail);

    useEffect(() => {
        if (am?.maintenanceType?.errorCode === 0) {
            setMaintenanceTypes(am?.maintenanceType?.resultObject);
        }
        if (autonomousMaintenanceId !== undefined && am?.amOrderById?.errorCode === 0) {
            var viewModel = am?.amOrderById?.resultObject;
            setSelectedPeriodType(viewModel.periodType);
            setPeriod(viewModel.period);
            setNotes(viewModel.notes);
            setEquipment(viewModel.equipmentId, viewModel.equipmentName);
            handleStartDate(new Date(viewModel.startDate));
            setRecurrence(viewModel.taskDates);
            setRuleText(viewModel.ruleText);
            setRuleString(viewModel.ruleString);
            setSelectedMaintenanceType(viewModel.maintenanceTypeId);
            setSelectedMaintenanceTypeName(viewModel.maintenanceTypeName);
            viewModel.taskDates && setOperatorDate(viewModel.taskDates[0]);

            var newSelectedGroupItemIDs = [];
            groupItemListData.forEach((element) => {
                if (viewModel.groupIds.includes(element.id)) {
                    element.checked = true;
                    newSelectedGroupItemIDs.push(element.id);
                }
            });
            setSelectedGroupItemIDs(newSelectedGroupItemIDs);
        }
        // const rule = new RRule(rrulestr(viewModel.ruleString).origOptions);
        // let rules = [];
        // rule.all().forEach(element => {
        //     rules.push(element.toISOString());
        // });
        // setRecurrence(rules);
        if (am?.amCreateOrder?.errorCode === 0) {
            dispatch(amCreateOrderAfter());
            if (fromPage === "list") {
                history.push({ pathname: "/autonomous-maintenance-order-list" });
            } else if (fromPage === "calendar") {
                history.push({ pathname: "/autonomous-maintenance-calendar" });
            } else {
                history.push({ pathname: "/technicianmainpage" });
            }
        }
        if (am?.amUpdateOrder?.errorCode === 0) {
            if (fromPage === "list") {
                history.push({ pathname: "/autonomous-maintenance-order-list" });
            } else if (fromPage === "calendar") {
                history.push({ pathname: "/autonomous-maintenance-calendar" });
            }
            dispatch(amUpdateOrderAfter());
        }
        if (am?.amOrderFiles?.errorCode === 0) {
            setDocumentList(Object.values(am?.amOrderFiles?.resultObject));
            setDocumentPopup(true);
            am.amOrderFiles = {};
        }
        if (am?.amAddFiles?.errorCode === 0) {
        }
        // if (pm?.pmAddFiles?.errorCode === 1) {
        //     generalCatchError({ data: { message: pm?.pmAddFiles?.message } });
        // }
    }, [am]);

    useEffect(() => {
        if (AutonomousMaintenanceDetail?.autonomousFiles) {
            setDocumentList(AutonomousMaintenanceDetail.autonomousFiles);
            setDocumentPopup(true);
            AutonomousMaintenanceDetail.autonomousFiles = null;
        }
    }, [AutonomousMaintenanceDetail?.autonomousFiles]);

    useEffect(() => {
        if (equipment?.eqByBarCode?.resultObject) {
            const newMachineStates = {
                selectedAreaCode: equipment.eqByBarCode.resultObject?.areaId,
                selectedAreaName: equipment.eqByBarCode.resultObject?.areaName,
                selectedMainEquipmentCode: equipment.eqByBarCode.resultObject?.mainEquipmentId,
                selectedMainEquipmentName: equipment.eqByBarCode.resultObject?.mainEquipment,
                selectedSubEquipmentCode: equipment.eqByBarCode.resultObject?.id,
                selectedSubEquipmentName: equipment.eqByBarCode.resultObject?.name,
            };
            setMachineStates(newMachineStates);
            setQrOpen(false);
            equipment.eqByBarCode.resultObject = null;
        }
    }, [equipment?.eqByBarCode?.resultObject]);

    const { itemGroupList } = useSelector(({ CheckItemGroup }) => CheckItemGroup);
    useEffect(() => {
        if (itemGroupList?.resultObject) {
            itemGroupList.resultObject.forEach((element) => {
                element.checked = false;
            });
            setGroupItemListData(itemGroupList.resultObject);
        }
    }, [itemGroupList]);

    const [maintenanceTypes, setMaintenanceTypes] = useState([]);
    const loadMaintenanceTypesData = () => {
        dispatch(getMaintenanceType());
    };

    //request detail
    const [notes, setNotes] = useState("");
    const handleNotes = (event) => {
        setNotes(event.target.value);
    };

    const [selectedMaintenanceType, setSelectedMaintenanceType] = useState(null);
    const [selectedMaintenanceTypeName, setSelectedMaintenanceTypeName] = useState(null);
    const handleMaintenanceTypeChange = (maintenanceId) => {
        if (maintenanceId != null) {
            const filteredType = maintenanceTypes.filter((item) => item.name.includes(maintenanceId));
            setSelectedMaintenanceType(filteredType[0].id);
            setSelectedMaintenanceTypeName(filteredType[0].name);
            return filteredType[0].id;
        }
        setSelectedMaintenanceType(null);
        setSelectedMaintenanceTypeName(null);
    };

    // set period type
    let [selectedPeriodType, setSelectedPeriodType] = useState(1);
    const handlePeriodTypeChange = (event) => {
        setSelectedPeriodType(event.target.value);
    };

    // set period
    let [period, setPeriod] = useState(0);
    const handlePeriod = (event) => {
        setPeriod(event.target.value);
    };

    // //set start date
    let [startDate, setStartDate] = useState(new Date());
    const handleStartDate = (date) => {
        date.setHours(0, 0);
        setStartDate(date);
        ls.set("startDate", date);
    };

    const getAutonomousMaintenanceOrder = () => {
        dispatch(getAMGetOrderDetailById({ id: autonomousMaintenanceId, showDates: false }));
    };

    //submit request
    const history = useHistory();
    const addOrderHandler = () => {
        let operatorDates = [];
        let date = moment(operatorDate).format("YYYY-MM-DD");
        operatorDates.push(date);
        const data = {
            notes: notes,
            equipmentId: machineStates.selectedSubEquipmentCode ?? machineStates.selectedMainEquipmentCode ?? 0,
            taskDates: fromPage === "operator" ? operatorDates : isMobile === true ? operatorDates : recurrence,
            ruleString: ruleString,
            ruleText: ruleText,
            maintenanceTypeId: selectedMaintenanceType || 0,
            groupIds: selectedGroupItemIDs,
        };
        data.taskDates = data.taskDates.map((item) => new Date(item).getFullYear() + "/" + ("0" + (new Date(item).getMonth() + 1)).slice(-2) + "/" + new Date(item).getDate());
        formData.append("autonomousOrder", JSON.stringify(data));
        dispatch(postAMCreateOrder(formData));
    };

    const updateOrderHandler = () => {
        const data = {
            id: parseInt(autonomousMaintenanceId),
            notes: notes,
            equipmentId: machineStates.selectedSubEquipmentCode ?? machineStates.selectedMainEquipmentCode ?? 0,
            taskDates: recurrence,
            ruleString: ruleString,
            maintenanceTypeId: selectedMaintenanceType || 0,
            ruleText: ruleText,
            groupIds: selectedGroupItemIDs,
        };
        dispatch(postAMUpdateOrder(data));
    };

    // Machine popup
    const initialMachineStates = {
        selectedAreaCode: null,
        selectedAreaName: null,
        selectedMainEquipmentCode: null,
        selectedMainEquipmentName: null,
        selectedSubEquipmentCode: null,
        selectedSubEquipmentName: null,
    };
    const [machineStates, setMachineStates] = useState(initialMachineStates);

    //QR Code
    let [qrOpen, setQrOpen] = useState(false);
    const [state, setState] = useState({
        qrResult: "No result",
    });

    const qrRef = useRef();
    let executedScroll = false;
    const handleScan = (data) => {
        executedScroll = qrScroll(qrRef, executedScroll);
        if (data) {
            setState({ ...state, qrResult: data });
            dispatch(getEqGetByBarcodeContext(data));
        }
    };

    const onRecurrenceSelected = (rules, ruleString, ruleText) => {
        setRecurrence(rules);
        setRuleString(ruleString);
        setRuleText(ruleText);
        setRecurrencePopupIsOpen(false);
    };

    // File Management
    const [documentPopup, setDocumentPopup] = useState(false);
    let [documentList, setDocumentList] = useState([]);
    const handleDocumentOpen = () => {
        dispatch(getAutonomousFiles(autonomousMaintenanceId));
    };

    const closeDocumentPopup = () => {
        setDocumentPopup(false);
    };

    const [autonomousFiles, setAutonomousFiles] = useState([]);
    const [formData, setFormData] = useState(new FormData());
    const [isFileUploaderPopupOpen, setIsFileUploaderPopupOpen] = useState(false);
    const UploadFiles = (files) => {
        const newFormData = getFormDataFromFiles(files);
        if (autonomousMaintenanceId !== undefined) {
            const payload = {
                autonomousId: autonomousMaintenanceId,
                data: newFormData,
            };
            dispatch(addAutonomousFiles(payload));
        } else {
            setFormData(newFormData);
            setAutonomousFiles(files);
        }
        setIsFileUploaderPopupOpen(false);
    };

    const DeleteFile = (selectedFiles) => {
        const selectedFileNames = getSelectedFileNames(selectedFiles);
        const payload = {
            autonomousId: autonomousMaintenanceId,
            fileNames: selectedFileNames,
        };
        dispatch(deleteAutonomousFiles(payload));
        setDocumentPopup(false);
    };

    const [operatorDate, setOperatorDate] = useState(isMobile ? new Date() : null);
    const onOperatorDateChangeHandler = (date) => {
        setOperatorDate(date);
    };

    // GroupItemList Popup
    const [isGroupItemList, setIsGroupItemList] = useState(false);
    const [groupItemListData, setGroupItemListData] = useState([]);
    const [selectedGroupItemIDs, setSelectedGroupItemIDs] = useState([]);

    const loadGroupItemListData = (includeNonValids) => {
        // parametre false gönderilip sadece valid olan grupları getirir.
        dispatch(getList(includeNonValids));
    };

    const handleGroupItemListOpen = () => {
        setIsGroupItemList(true);
    };

    const handleGroupItemListConfirm = (newGroupItemListData) => {
        const newSelectedGroupItemIDs = [];
        newGroupItemListData.forEach((groupItem) => {
            if (groupItem.checked) {
                newSelectedGroupItemIDs.push(groupItem.id);
            }
        });

        setGroupItemListData(newGroupItemListData);
        setSelectedGroupItemIDs(newSelectedGroupItemIDs);
        setIsGroupItemList(false);
    };

    const handleGroupItemListCancel = () => {
        setIsGroupItemList(false);
    };

    // Validation
    const [error, setError] = useState({
        machineText: t("SelectAMachine"),
        maintenanceTypeText: t("SelectAMaintenanceType"),
    });
    const [isDisable, setIsDisable] = useState(true);

    useEffect(() => {
        if (selectedMaintenanceType) {
            setError({ ...error, maintenanceTypeText: "" });
        } else {
            setError({ ...error, maintenanceTypeText: t("SelectAMaintenanceType") });
        }
    }, [selectedMaintenanceType, recurrence]);

    useEffect(() => {
        if (error.maintenanceTypeText === "" && (machineStates.selectedSubEquipmentCode || machineStates.selectedMainEquipmentCode) && (recurrence?.length > 0 || operatorDate !== null)) {
            setIsDisable(false);
        } else {
            setIsDisable(true);
        }
    }, [error]);

    let [barcodeOpen, setBarcodeOpen] = useState(false);
    const OpenBarcodeScanner = () => {
        if (barcodeOpen) {
            return (
                <div>
                    <TextField
                        autoFocus
                        onChange={(e) => HandleScanBarcode(e)}
                        onKeyDown={handleKeypress}
                        style={{ width: "100%", marginBottom: 10, marginTop: 20 }}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton edge="end" color="primary" onClick={handleSubmit}>
                                        <SearchIcon />
                                    </IconButton>
                                </InputAdornment>
                            ),
                        }}
                    />
                </div>
            );
        } else {
            return null;
        }
    };

    const HandleScanBarcode = (event) => {
        if (event.target.value) {
            setState({ ...state, result: event.target.value });
        }
    };

    const handleKeypress = (e) => {
        //it triggers by pressing the enter key
        if (e.keyCode === 13) {
            setBarcodeOpen(false);
            dispatch(getEqGetByBarcodeContext(e.target.value));
        }
    };

    const handleSubmit = () => {
        setBarcodeOpen(false);
        dispatch(getEqGetByBarcodeContext(state.result));
    };

    return (
        <div>
            {pageLoaded === true ? (
                <Container id="cam_Container" fixed maxWidth="xs" style={{ marginTop: 20 }}>
                    <Grid id="cam_Grid" container justifyContent="center" style={{ marginTop: 30 }}>
                        <Grid id="rb_grid_1" item xs={12}>
                            <IconButton id="rb_iconQrBtn" onClick={() => setQrOpen(true)}>
                                <QrCode2Icon id="rb_centerFcs" className={classes.button} color="primary" />
                            </IconButton>
                            <IconButton id="rb_iconQrBtn" onClick={() => setBarcodeOpen(true)}>
                                <CropFreeIcon id="rb_centerFcs" className={classes.button} color="primary" />
                            </IconButton>
                        </Grid>
                        <Divider id="rb_divider" variant="middle" sx={{ width: "70%", marginTop: "10px" }} />
                        <Grid id="rb_grid_1" item xs={12}>
                            <TextField
                                id="ctbp_TextField_1"
                                multiline
                                maxRows={4}
                                defaultValue={t("ScanQRCodeOrChooseMachine")}
                                InputProps={{ readOnly: true }}
                                variant="outlined"
                                sx={{ width: "80%", marginTop: "10px" }}
                            />
                        </Grid>

                        <Grid id="cam_Grid_2" item xs={12}>
                            {qrOpen === true ? (
                                <div ref={qrRef}>
                                    <QrReader id="cam_QrReader" scanDelay={500} onResult={handleScan} constraints={{ facingMode: "environment" }} style={{ width: "100%", marginBottom: 10 }} />
                                </div>
                            ) : null}
                        </Grid>
                        {OpenBarcodeScanner()}

                        <Grid id="cam_Grid_4" item xs={12} style={{ marginTop: 20 }}>
                            <FormControl id="cam_FormControl" variant="outlined" style={{ width: "90%" }}>
                                <Machine setMachineStates={setMachineStates} machineStates={machineStates} isAreaNotFiltered={true} size="normal" error={error} setError={setError} />
                            </FormControl>
                        </Grid>

                        <Grid id="cam_Grid_5" item xs={12}>
                            <FormControl id="cam_FormControl_1" variant="outlined" style={{ width: "90%" }}>
                                <Autocomplete
                                    id="cam_Autocomplete"
                                    defaultValue={""}
                                    value={selectedMaintenanceTypeName != null ? selectedMaintenanceTypeName : null}
                                    onChange={(event, newValue) => {
                                        handleMaintenanceTypeChange(newValue);
                                    }}
                                    options={maintenanceTypes.map((option) => option.name)}
                                    renderInput={(params) => (
                                        <TextField
                                            id="cam_TextField_2"
                                            {...params}
                                            margin="normal"
                                            label={t("MaintenanceType")}
                                            variant="outlined"
                                            error={error.maintenanceTypeText.length > 0}
                                            helperText={error.maintenanceTypeText}
                                        />
                                    )}
                                />
                            </FormControl>
                        </Grid>

                        {fromPage !== "operator" && !isMobile ? (
                            <Grid id="cam_Grid_6" container item xs={12} style={{ marginTop: 20 }}>
                                <Grid id="cam_Grid_8" item xs={12}>
                                    <Button id="cam_Button" onClick={() => setRecurrencePopupIsOpen(true)} variant="contained" color="secondary">
                                        {t("ChooseMaintenanceSchedule")}
                                    </Button>
                                    <FormHelperText
                                        id="cam_FormHelperText"
                                        data-tip
                                        data-for="datesInfoText"
                                        style={{ textAlign: "center", width: "150px", marginLeft: "120px", color: recurrence && recurrence.length === 0 ? "red" : "#888" }}
                                    >
                                        {recurrence && recurrence.length > 0 ? `${recurrence.length}  ${t("DateSelected")}` : t("MaintenanceScheduleNotSelected")}
                                    </FormHelperText>
                                    <ReactTooltip id="cam_ReactTooltip" place="top" effect="solid">
                                        {recurrence.map((item, index) => (
                                            <MenuItem id={"cam_ReactTooltip_" + index} style={{ fontSize: 12 }}>
                                                {moment(item).format("DD-MM-YYYY")}
                                            </MenuItem>
                                        ))}
                                    </ReactTooltip>
                                </Grid>
                                <Grid id="cam_Grid_9" item xs={12}>
                                    {autonomousMaintenanceId ? (
                                        <Tooltip id="cam_Tooltip" title={t("ShowFiles")}>
                                            <IconButton id="cam_IconButton_2" onClick={handleDocumentOpen} style={{ marginBottom: 10, marginRight: 15 }} size="large">
                                                <CloudDownload id="cam_CloudDownload" sx={{ width: 50, height: 50, padding: 0 }} style={{ fill: "#757575" }} />
                                            </IconButton>
                                        </Tooltip>
                                    ) : null}

                                    <Tooltip id="cam_Tooltip_1" title={t("UploadFile")}>
                                        <IconButton id="cam_IconButton_3" onClick={() => setIsFileUploaderPopupOpen(true)} style={{ marginBottom: 10, marginRight: 15 }} size="large">
                                            <CloudUpload id="cam_CreateNewFolder" sx={{ width: 50, height: 50, padding: 0 }} style={{ fill: "#757575" }} />
                                        </IconButton>
                                    </Tooltip>

                                    <Tooltip id="cam_Tooltip_2" title={t("SelectInstruction")}>
                                        <IconButton id="cam_IconButton_4" onClick={handleGroupItemListOpen} style={{ marginBottom: 10 }} size="large">
                                            <Add id="cam_Add" sx={{ width: 50, height: 50, padding: 0 }} style={{ fill: "#757575" }} />
                                        </IconButton>
                                    </Tooltip>
                                </Grid>
                            </Grid>
                        ) : (
                            <Grid id="cam_Grid_7" item xs={12} style={{ marginTop: 10 }}>
                                <DatePicker
                                    id="cam_DatePicker"
                                    variant="inline"
                                    renderInput={(_props) => <TextField {..._props} />}
                                    inputFormat="dd.MM.yyyy"
                                    margin="normal"
                                    minDate={new Date()}
                                    value={operatorDate}
                                    onChange={onOperatorDateChangeHandler}
                                    label={t("StartDate")}
                                    style={{ height: "40px", width: "100%" }}
                                    KeyboardButtonProps={{
                                        "aria-label": "change date",
                                    }}
                                />
                            </Grid>
                        )}

                        <Grid id="cam_Grid_10" item xs={12} style={{ marginTop: 10 }}>
                            <TextField id="cam_TextField_3" style={{ width: "90%" }} multiline label={t("MaintenanceNote")} variant="outlined" onChange={handleNotes} value={notes} />
                        </Grid>

                        <Grid id="cam_Grid_11" item xs={12} style={{ marginTop: 20 }}>
                            {(fromPage === "list" || fromPage === "calendar") && autonomousMaintenanceId !== undefined ? (
                                <Button id="cam_Button_1" style={{ marginBottom: 20 }} onClick={() => updateOrderHandler()} variant="contained" color="primary" disabled={isDisable}>
                                    {t("Save")}
                                </Button>
                            ) : (
                                <Button id="cam_Button_2" style={{ marginBottom: 20 }} onClick={() => addOrderHandler()} variant="contained" color="primary" disabled={isDisable}>
                                    {t("Save")}
                                </Button>
                            )}
                        </Grid>
                    </Grid>
                </Container>
            ) : null}

            {isGroupItemList ? <GroupItemListPopup open={isGroupItemList} onConfirm={handleGroupItemListConfirm} onCancel={handleGroupItemListCancel} groupItemListData={groupItemListData} /> : null}

            {documentPopup === true ? (
                <DocumentPopup isMaintenanceDocuments={true} isEquipmentDocuments={false} list={documentList} open={documentPopup} deleteFile={DeleteFile} close={() => closeDocumentPopup()} />
            ) : null}

            {isFileUploaderPopupOpen ? <FileUploaderPopup isOpen={isFileUploaderPopupOpen} files={autonomousFiles} onCancel={() => setIsFileUploaderPopupOpen(false)} onConfirm={UploadFiles} /> : null}

            <RecurrencePopup title={t("ChooseMaintenanceSchedule")} open={recurrencePopupIsOpen} onClose={() => setRecurrencePopupIsOpen(false)}>
                <RuleGenerator onSubmit={onRecurrenceSelected} rule={ruleString !== "" ? rrulestr(ruleString).origOptions : null} />
            </RecurrencePopup>

            <LoadingBackdrop />
        </div>
    );
}
